/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedLetterJ = createReactComponent(
  "square-rounded-letter-j",
  "IconSquareRoundedLetterJ",
  [
    ["path", { d: "M10 8h4v6a2 2 0 1 1 -4 0", key: "svg-0" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareRoundedLetterJ as default };
//# sourceMappingURL=IconSquareRoundedLetterJ.js.map
